





























































































































































import { DbProduct } from '@/model/DbProduct';
import { Actions } from '@/store/actions';
import _ from 'lodash';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { SnackType } from '../../events';
import { productsService } from '../../services/products.service';
import { Getters } from '../../store/getters';
import { Mutations } from '../../store/mutations';
import {
  IsValidPriceRule,
  LengthRule,
  NoCurrencyRule,
  NotEmptyRule,
  ValidationRule,
} from '../../validation/validation.rules';

import Base from '../core/Base.vue';
import {
  ALLERGENS,
  ORIGINS,
  PRODUCT_NUTRISCORE,
  PRODUCT_TYPES_NAMES,
} from '../menus/menus.constants';
import DbProductDelete from './DbProductDelete.vue';

@Component({
  components: {
    DbProductDelete,
  },
})
export default class DbProductFormDialog extends Base {
  mProduct: Partial<DbProduct> = {};

  valid = false;

  @Watch('formDialogDb')
  opening(newValue: boolean, oldValue: boolean): void {
    if (newValue && !oldValue) {
      // Ouverture
      if (this.dbProduct) {
        this.mProduct = _.cloneDeep(this.dbProduct);
      } else {
        this.clear();
      }
    }
  }

  get edition() {
    return Boolean(this.mProduct._id);
  }

  async submit(closeAfter = false) {
    this.$store.commit(Mutations.START_LOADING);

    const product: DbProduct = {
      ...(this.mProduct as DbProduct),
      sides: this.mProduct.type === 'ACC' ? '' : this.mProduct.sides,
      price: this.mProduct.price || 0,
      nutriscore: this.mProduct.nutriscore || 0,
    };
    Promise.resolve()
      .then(async () => {
        if (this.edition && product._id)
          return productsService.update(product._id, product).then(
            () => {
              return 'Produit modifié avec succès';
            },
            error => {
              this.snack(
                `Erreur lors de la modification du produit. (code ${error.response?.status})`,
                SnackType.ERROR,
                5000,
              );
            },
          );
        return productsService.create(product).then(
          () => {
            return 'Produit ajouté avec succès';
          },
          error => {
            this.snack(
              `Erreur lors de l'ajout du produit. (code ${error.response?.status})`,
              SnackType.ERROR,
              5000,
            );
          },
        );
      })
      .finally(() => {
        this.$store.dispatch(Actions.SET_DB_PRODUCTS);
        if (closeAfter) this.close();
        else this.clear();
      })
      .then(async okMessage => {
        if (okMessage) this.snack(okMessage);
      })
      .finally(() => {
        this.$store.commit(Mutations.RELEASE_LOADING);
      });
  }

  close() {
    this.formDialogDb = false;
  }

  clear() {
    this.mProduct = {};
    // this.edition = false;
    // if (this.$refs.nameInput) (this.$refs.nameInput as HTMLElement).focus();
    if (this.$refs.form) {
      const form = this.$refs.form as HTMLFormElement;
      form.resetValidation();
    }
  }

  get nameRules(): ValidationRule[] {
    return [NotEmptyRule];
  }

  get priceRules(): ValidationRule[] {
    return [NoCurrencyRule, IsValidPriceRule];
  }

  get typeRules(): ValidationRule[] {
    return [NotEmptyRule];
  }

  get originsRules(): ValidationRule[] {
    return [];
  }

  get sidesRules(): ValidationRule[] {
    return [LengthRule(0, 200)];
  }

  get compositionRules(): ValidationRule[] {
    return [LengthRule(0, 200)];
  }

  get productTypeItems(): unknown[] {
    return Object.entries(PRODUCT_TYPES_NAMES).map(([typeCode, typeName]) => {
      return { value: typeCode, text: typeName };
    });
  }

  get allergensItems(): unknown[] {
    return Object.entries(ALLERGENS).map(([code, name]) => {
      return { value: code, text: name };
    });
  }

  get originsItems(): unknown[] {
    return Object.entries(ORIGINS).map(([code, name]) => {
      return { value: code, text: name };
    });
  }

  get nutriscoreItems(): unknown[] {
    return Object.entries(PRODUCT_NUTRISCORE).map(([code, name]) => {
      return { value: parseInt(code, 10), text: name };
    });
  }

  set formDialogDb(v: boolean) {
    this.$store.commit(Mutations.FORM_DIALOG_DB, v);
  }

  get formDialogDb(): boolean {
    return this.$store.getters[Getters.FORM_DIALOG_DB];
  }

  get targetGroupsItems(): { value: string; text: string }[] {
    if (this.site?.targetGroups) {
      const items = this.site.targetGroups.map(targetGroup => ({
        value: targetGroup.code,
        text: targetGroup.name,
      }));
      return items;
    }
    return [];
  }
}
